// extracted by mini-css-extract-plugin
export default {"section":"UberUns_section__ZCID-","text":"UberUns_text__MLxHg"};